<div class="space-y-5">
  <!-- Header -->
  <div class="flex items-center justify-between">
    <h2 class="text-2xl font-bold tracking-tight text-primary-800 dark:text-primary-400">Institutions</h2>
    <button (click)="getInstitutionOfAProduct()"
      class="px-3 py-1.5 rounded-lg text-slate-600 dark:text-slate-400 hover:text-slate-800 dark:text-slate-100 bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 border border-slate-200 dark:border-slate-700 transition-colors flex items-center gap-1.5 text-xs font-semibold" title="Refresh">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
      </svg>

      <span>Refresh</span>
    </button>
  </div>

  <!-- Table Container -->
  <div class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm overflow-hidden">
    <!-- Table Header -->
    <div class="grid grid-cols-[75px_2fr_1.5fr_1fr_1.5fr_90px_70px] gap-2 px-5 py-2.5 bg-slate-50 dark:bg-slate-800/60 border-b border-slate-200 dark:border-slate-700">
      <div><p class="text-xs font-semibold text-slate-400">Created At</p></div>
      <div><p class="text-xs font-semibold text-slate-400">Institution</p></div>
      <div><p class="text-xs font-semibold text-slate-400">Address</p></div>
      <div><p class="text-xs font-semibold text-slate-400">Phone</p></div>
      <div><p class="text-xs font-semibold text-slate-400">Email</p></div>
      <div><p class="text-xs font-semibold text-slate-400">Status</p></div>
      <div class="text-center"><p class="text-xs font-semibold text-slate-400">Actions</p></div>
    </div>

    <!-- Table Body -->
    <div class="overflow-y-auto max-h-[400px]">
      @if (isInstitutionLoading) {
      <div class="flex items-center justify-center py-20">
        <app-progress-loader></app-progress-loader>
      </div>
      } @else {
      @if (institutions && institutions.length > 0) {
      @for (institution of institutions; track $index) {
      <app-institution-tabel [institution]="institution" [showProfileIcon]="false"></app-institution-tabel>
      }
      } @else {
      <div class="flex flex-col items-center justify-center py-24 text-center px-4">
        <div class="w-12 h-12 bg-slate-50 dark:bg-slate-800/60 rounded-full flex items-center justify-center mx-auto mb-4 border border-slate-100 dark:border-slate-700/50">
          <span class="text-xl text-slate-300">!</span>
        </div>
        <h3 class="text-sm font-bold text-slate-900 dark:text-white">No Institutions Found</h3>
        <p class="text-xs text-slate-500 dark:text-slate-400 mt-2 leading-relaxed">There are no institutions using this product yet.</p>
      </div>
      }
      }
    </div>

    <!-- Pagination -->
    @if (!isInstitutionLoading && institutions.length > 0) {
    <div class="border-t border-slate-100 dark:border-slate-700/50 px-4">
      <app-pagination
        [totalItems]="allInstitutions.meta.totalPages"
        [itemsPerPage]="allInstitutions.meta.perPage ?? 10"
        [currentPage]="allInstitutions.meta.page ?? 1"
        (pageChange)="onPageChange($event)">
      </app-pagination>
    </div>
    }
  </div>
</div>
